<template>
  <div class="main-in">
    <div class="container" v-cloak>
      <!-- 面包屑 -->
      <div is="titlebox" :nav='JSON.parse(nav)'></div>

      <!-- 内容区 -->
      <div class="content min-h">
        <!-- 基本信息区 -->
        <div class="detail-header">
          <div class="detail-photo">
            <div class="photo-batch" v-if="info.batchName">{{ info.batchName }}</div>
            <img v-if="info.photo" :src="$imgUrl + '/' + info.photo" class="photo-img">
            <img v-else src="@/assets/img/noheader.jpg" class="photo-img">
          </div>
          <div class="detail-summary">
            <div class="ds-name">{{ info.name }}</div>
            <div class="ds-meta">
              <div class="meta-item"><span class="label">性别</span><span class="value">{{ info.gender_dictText || info.gender || '--' }}</span></div>
              <div class="meta-item"><span class="label">出生年月</span><span class="value">{{ info.birthDate || '--' }}</span></div>
              <div class="meta-item meta-full"><span class="label">现工作单位及职务</span><span class="value">{{ info.workUnit || '--' }}</span></div>
              <div class="meta-item meta-full"><span class="label">原挂职单位及职务</span><span class="value">{{ info.formerUnit || '--' }}</span></div>
              <div class="meta-item meta-full"><span class="label">毕业院校及专业（博士）</span><span class="value">{{ info.graduateSchool || '--' }}</span></div>
              <div class="meta-item meta-full"><span class="label">主要研究领域</span><span class="value">{{ info.researchArea || '--' }}</span></div>
            </div>
          </div>
        </div>

        <!-- 信息区块 -->
        <div class="info-block" v-if="info._talentTitles && info._talentTitles.length">
          <div class="block-title">主要人才称号（含入选年份）</div>
          <div class="block-content">
            <div class="item-line" v-for="(item, i) in info._talentTitles" :key="i">
              <span class="dot">•</span>{{ item }}{{ i < info._talentTitlesLen - 1 ? '；' : '' }}
            </div>
          </div>
        </div>

        <div class="info-block" v-if="info._academicPartTime && info._academicPartTime.length">
          <div class="block-title">主要学术兼职</div>
          <div class="block-content">
            <div class="item-line" v-for="(item, i) in info._academicPartTime" :key="i">
              <span class="dot">•</span>{{ item }}{{ i < info._academicPartTimeLen - 1 ? '；' : '' }}
            </div>
          </div>
        </div>

        <div class="info-block" v-if="info._achievementAwards && info._achievementAwards.length">
          <div class="block-title">学术成果奖励（省部级及以上）</div>
          <div class="block-content">
            <div class="item-line" v-for="(item, i) in info._achievementAwards" :key="i">
              <span class="dot">•</span>{{ item }}{{ i < info._achievementAwardsLen - 1 ? '；' : '' }}
            </div>
          </div>
        </div>

        <div class="info-block" v-if="info._representativeBooks && info._representativeBooks.length">
          <div class="block-title">代表性专著</div>
          <div class="block-content">
            <div class="item-line" v-for="(item, i) in info._representativeBooks" :key="i">
              <span class="dot">•</span>{{ item }}{{ i < info._representativeBooksLen - 1 ? '；' : '' }}
            </div>
          </div>
        </div>

        <div class="info-block" v-if="info._representativeProjects && info._representativeProjects.length">
          <div class="block-title">主持的代表性课题（国家级、省部级）</div>
          <div class="block-content">
            <div class="item-line" v-for="(item, i) in info._representativeProjects" :key="i">
              <span class="dot">•</span>{{ item }}{{ i < info._representativeProjectsLen - 1 ? '；' : '' }}
            </div>
          </div>
        </div>

        <div class="info-block" v-if="info._papersReportsPatents && info._papersReportsPatents.length">
          <div class="block-title">高质量论文、咨政报告及发明专利</div>
          <div class="block-content">
            <div class="item-line" v-for="(item, i) in info._papersReportsPatents" :key="i">
              <span class="dot">•</span>{{ item }}{{ i < info._papersReportsPatentsLen - 1 ? '；' : '' }}
            </div>
          </div>
        </div>

        <!-- 返回 -->
        <div class="back-link" @click="$router.push('/doctor')">← 返回列表</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorDetail',
  computed: {
    nav() {
      return JSON.stringify([
        { label: '博士风采', path: '/doctor', type: 0 },
        { label: '详情', path: '/doctorDetail', id: 0 }
      ])
    }
  },
  data() {
    return {
      info: {}
    }
  },
  mounted() {
    this.$util.goTop()
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      const id = this.$route.query.id
      if (!id) return
      this.$get('/web/doctor/queryById', { id }).then(res => {
        if (res.success) {
          const info = res.result || {}
          const textFields = ['talentTitles','academicPartTime','achievementAwards','representativeBooks','representativeProjects','papersReportsPatents']
          textFields.forEach(f => {
            const arr = info[f] ? info[f].split(/[;；]/).filter(s => s.trim()) : []
            info['_' + f] = arr
            info['_' + f + 'Len'] = arr.length
          })
          this.info = info
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container { background: #ffffff; }

.content {
  width: 100%; box-sizing: border-box;
  padding: 30px 50px 50px;
}

/* 基本信息区 */
.detail-header {
  display: flex; gap: 36px; padding-bottom: 28px;
  border-bottom: 1px solid #EBEBEB; margin-bottom: 28px;
  align-items: flex-start;
}
.detail-photo {
  width: 180px; height: 180px; background: #F0F0F0; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; overflow: hidden; position: relative;
  border: 4px solid #f0e9e9;
}
.detail-photo .photo-batch {
  position: absolute; bottom: 0; left: 0; right: 0;
  background: rgba(186,7,17,0.85); color: #fff; font-size: 13px;
  padding: 6px 0; z-index: 2; text-align: center;
}
.detail-photo .photo-img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
.detail-photo .placeholder { font-size: 56px; color: #CCC; }
.detail-summary { flex: 1; }
.detail-summary .ds-name {
  font-size: 26px; font-weight: bold; color: #333;
  margin-bottom: 14px; padding-bottom: 8px;
  border-bottom: 1px dashed #ddd;
}
.detail-summary .ds-meta {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 14px 36px;
}
.detail-summary .ds-meta .meta-item {
  display: flex; align-items: baseline; font-size: 15px; color: #444; line-height: 2.1;
}
.detail-summary .ds-meta .meta-item.meta-full {
  grid-column: 1 / -1;
}
.detail-summary .ds-meta .label {
  color: #666; min-width: 60px; flex-shrink: 0;
  padding: 3px 10px; background: #f7f7f7; border-radius: 3px;
  font-size: 13px; margin-right: 14px; text-align: center;
  border: 1px solid #eee;
}
.detail-summary .ds-meta .value {
  flex: 1; word-break: break-all;
}
.detail-summary .ds-batch-inline { margin-top: 16px; }
.detail-summary .ds-batch-inline .batch-inline-tag {
  display: inline-block; background: #BA0711; color: #fff;
  font-size: 13px; padding: 4px 16px; border-radius: 3px;
}

/* 信息区块 */
.info-block { margin-bottom: 28px; }
.info-block .block-title {
  font-size: 18px; font-weight: bold; color: #BA0711;
  padding: 10px 18px; margin-bottom: 18px;
  border-left: 4px solid #BA0711; background: #FFF8F8;
  border-radius: 0 4px 4px 0;
}
.info-block .block-content { font-size: 15px; line-height: 2.4; color: #444; padding-left: 18px; }
.info-block .block-content .dot { color: #BA0711; margin-right: 10px; font-weight: bold; flex-shrink: 0; }
.info-block .block-content .item-line { display: flex; margin-bottom: 5px; }

/* 返回 */
.back-link {
  font-size: 14px; color: #BA0711; cursor: pointer;
  margin-top: 32px; padding-top: 22px;
  border-top: 1px solid #EBEBEB; text-align: center;
}
</style>
